import styled from '@emotion/styled';
import { ThemeProvider } from '@mui/material/styles';
import type { FunctionComponent } from 'react';

import { Button } from '~/ui/core/button/Button';
import { IconSidebarHiddenLeftWide, IconSidebarSimpleLeftWide } from '~/ui/core/icons';
import { theme } from '~/ui/theme/cobrainer-theme';

import { CompanyLogoV2 } from './CompanyLogoV2';
import { useNavigationMenu } from './NavigationMenuContext';
import { DrawerHeader, NavigationMenuV2 } from './NavigationMenuV2';

const ToolbarContainer = styled('section')(({ theme }) => ({
    alignItems: 'center',
    backgroundColor: theme.colors.gray[200],
    display: 'grid',
    gap: theme.spacing['3xl'],
    gridTemplateColumns: 'auto 160px 1fr',
    paddingLeft: theme.spacing.xxl,
    paddingRight: theme.spacing.xxl,
}));

export const MenuBarV2: FunctionComponent = () => {
    const { isOpen, toggleMenu } = useNavigationMenu();

    return (
        <ThemeProvider theme={theme}>
            <ToolbarContainer data-testid="menu-bar">
                <DrawerHeader>
                    <Button iconOnly={true} style={{ marginLeft: '-0.60rem' }} variant="ghost" onClick={toggleMenu}>
                        <span className="flex items-center text-gray-600">
                            {isOpen ? (
                                <IconSidebarSimpleLeftWide size={theme.typography.body.M.regular.fontSize} />
                            ) : (
                                <IconSidebarHiddenLeftWide size={theme.typography.body.M.regular.fontSize} />
                            )}
                        </span>
                    </Button>
                </DrawerHeader>
                <CompanyLogoV2 />
                <NavigationMenuV2 />
            </ToolbarContainer>
        </ThemeProvider>
    );
};
